import {SearchThemeKeywordInput} from '../../../../graphql/generated/types';
import {
  SearchThemeKeywordSearchParam,
  validateSearchThemeKeywordSortType,
} from '../../util/typeguard';

export function createSearchThemeKeywordInput(
  searchParam: SearchThemeKeywordSearchParam
): SearchThemeKeywordInput {
  const filterList = searchParam.filterList.split('|');

  return {
    filterList,
    ...(!!searchParam.sortType &&
      validateSearchThemeKeywordSortType(searchParam.sortType) && {
        sortType: searchParam.sortType,
      }),
  };
}
